import { useNavigate } from 'react-router-dom';
import { ContractDetailPage as SharedContractDetailPage } from '@/features/contracts/components/ContractDetailPage';

export function ContractDetailPage() {
  const navigate = useNavigate();

  return (
    <div className="tw-pt-4">
      <SharedContractDetailPage
        embedded
        onBack={() => navigate(-1)}
      />
    </div>
  );
}
